import './favorites.common';
import './features/notes';
import attachPopoutMenu from './helpers/attach-popout-menu';

attachPopoutMenu('.js-add-favorite', '.js-add-favorite__choice', 'hover');
